var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafariShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50345 10.4604C8.7309 10.4604 8.92389 10.2662 8.92389 10.0288V2.28058L8.89632 1.23741L9.50976 1.89928L10.6815 3.17266C10.7573 3.25899 10.8676 3.30216 10.971 3.30216C11.1847 3.30216 11.357 3.13669 11.357 2.91367C11.357 2.79137 11.3087 2.70504 11.2329 2.61871L8.80672 0.143885C8.70333 0.0359712 8.61373 0 8.50345 0C8.39316 0 8.30356 0.0359712 8.20017 0.143885L5.77398 2.61871C5.69127 2.70504 5.64302 2.79137 5.64302 2.91367C5.64302 3.13669 5.80844 3.30216 6.02901 3.30216C6.1324 3.30216 6.24957 3.25899 6.32539 3.17266L7.49713 1.89928L8.11057 1.23741L8.083 2.28058V10.0288C8.083 10.2662 8.27599 10.4604 8.50345 10.4604ZM4.53331 16H12.4667C13.8107 16 14.5 15.2806 14.5 13.8993V6.54676C14.5 5.15827 13.8107 4.43885 12.4667 4.43885H10.5023V5.33094H12.446C13.2111 5.33094 13.6453 5.76259 13.6453 6.58993V13.8489C13.6453 14.6835 13.2111 15.1079 12.446 15.1079H4.5471C3.77513 15.1079 3.35468 14.6835 3.35468 13.8489V6.58993C3.35468 5.76259 3.77513 5.33094 4.5471 5.33094H6.50459V4.43885H4.53331C3.18926 4.43885 2.5 5.15108 2.5 6.54676V13.8993C2.5 15.2878 3.18926 16 4.53331 16Z",
    fill: "#2E7CF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafariShare);
export default __webpack_public_path__ + "static/media/safari-share.64f7bab6c51361c06d5b9b2b6a1a106a.svg";
export { ForwardRef as ReactComponent };